export function getJoinUrl(roomId: string): string | null {
  if (typeof window === 'undefined') return null;
  if (!roomId) return null;

  const url = new URL(window.location.href);
  url.search = '';
  url.hash = '';
  url.pathname = `/j/${roomId}`;
  return url.toString();
}

